import { render, staticRenderFns } from "./CustomizeMetalAU.vue?vue&type=template&id=f96c228c&scoped=true"
import script from "./CustomizeMetalAU.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAU.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAU.vue?vue&type=style&index=0&id=f96c228c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96c228c",
  null
  
)

export default component.exports